import React from 'react';
import { Link } from 'react-router-dom';

/**
 * @typedef {object} LinkToastProps
 * @property {string} message
 * @property {string} url
 * @property {boolean} [openInNewTab]
 * @property {() => void} [closeToast]
 */

/**
 * @param {LinkToastProps} props
 */
export const LinkToast = props => {
  const { message, url, closeToast, openInNewTab = false } = props;

  const handleClick = () => {
    closeToast();
  };

  return (
    <Link to={url} target={openInNewTab ? '_blank' : undefined} onClick={handleClick}>
      {message}
    </Link>
  );
};
